import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { focusElement } from '~/platform/utilities/ui';
import { getFocusableElements } from 'platform/forms-system/src/js/utilities/ui';
import { toggleDirectDepositEdit } from '../actions/directDeposit';

export const useDirectDepositEffects = ({
  wasSaving,
  wasEditing,
  saveError,
  ui,
  setShowUpdateSuccess,
  setFormData,
  editButtonRef,
  hasUnsavedFormEdits,
}) => {
  const dispatch = useDispatch();

  // page setup effects
  // focus on the heading, set the document title,
  // clear edit state and remove any pending form data
  useEffect(() => {
    focusElement('[data-focus-target]');
    document.title = `Direct Deposit Information | Veterans Affairs`;
    dispatch(toggleDirectDepositEdit(false));
    setFormData({});
  }, [dispatch, setFormData]);

  // effect to show an alert when the form is dirty and navigating away
  useEffect(() => {
    if (hasUnsavedFormEdits) {
      window.onbeforeunload = () => true;
      return;
    }
    window.onbeforeunload = undefined;
  }, [hasUnsavedFormEdits]);

  // effects to show the success alert and clear form data after a successful save
  useEffect(() => {
    if (!ui.isSaving && !saveError && wasSaving) {
      setShowUpdateSuccess(true);
      setFormData({});
    }
  }, [wasSaving, ui.isSaving, saveError, setFormData, setShowUpdateSuccess]);

  // focus on the first form element when entering edit mode
  // clear update success alert if it's showing
  useEffect(() => {
    if (ui.isEditing && !wasEditing) {
      setTimeout(() => {
        // Find the form container and get the first focusable element
        const formContainer = document.querySelector('form');
        if (formContainer) {
          const focusableElements = getFocusableElements(formContainer);
          if (focusableElements.length > 0) {
            focusableElements[0].focus();
          }
        }
      }, 100);
      setShowUpdateSuccess(false);
    }
  }, [ui.isEditing, wasEditing, setShowUpdateSuccess]);

  // focus on the edit button after leaving the update view
  useEffect(() => {
    if (wasEditing && !ui.isEditing) {
      focusElement('button', {}, editButtonRef.current);
    }
  }, [wasEditing, ui.isEditing, editButtonRef]);
};
